import { useAnalytics } from '@repo/segment/Analytics';
import { useAnalyticsPageView } from '@repo/segment/Analytics/AnalyticsPageView';

type FeatureInteractedProps = {
  entityName: string;
  entitySection: string;
  additionalAttributes?: object;
  contextCampaignUtmCampaign?: string;
};

export const useFeatureInteracted = ({
  entityName,
  entitySection,
  additionalAttributes,
  contextCampaignUtmCampaign,
}: FeatureInteractedProps) => {
  const { analytics, deployableName, deployableVersion, deviceId, gitSha } = useAnalytics();
  const { pageViewId, pageName, pageType } = useAnalyticsPageView();
  const segmentInstance = analytics?.segmentInstance;

  const locationHref = typeof window !== 'undefined' ? window?.location?.href : undefined;
  const locationPathname = typeof window !== 'undefined' ? window.location.pathname : '';

  const segmentProps = {
    entity_name: entityName,
    entity_section: entitySection,
    impression_page_url: locationHref,
    impression_pageview_id: pageViewId,
    impression_page_name: pageName || locationPathname,
    context_campaign_utm_campaign: contextCampaignUtmCampaign,
    deployable_name: deployableName,
    deployable_version: deployableVersion,
    traditional_device_id: deviceId,
    additional_attributes: { ...additionalAttributes, page_type: pageType },
  };

  return (overrideProps?: Record<string, string | object> | null, callback?: (() => void) | null) =>
    segmentInstance &&
    void segmentInstance
      .track(
        'Feature Interacted',
        {
          ...segmentProps,
          ...overrideProps,
          additional_attributes: {
            ...segmentProps.additional_attributes,
            ...(typeof overrideProps?.additional_attributes === 'object'
              ? overrideProps.additional_attributes
              : {}),
          },
        },
        {
          context: {
            app: {
              name: deployableName,
              version: gitSha,
            },
          },
        },
      )
      ?.finally(() => {
        callback?.();
      });
};
